import { getABTestsForTracking } from '@core/abTesting/abTesting'
import { getBackendExperimentsForTracking } from '@core/abTesting/backend/backendABTesting'
import { getGlobalConfig } from '@core/globalConfig'
import { pruneNilValues } from '@core/object'
import { getGlobalStore, pageLoadIdSelector } from '@core/store'
import { getFWReferrerForTracking } from '@core/tracking/attribution/getFWReferrerForTracking'
import { getUTM } from '@core/tracking/attribution/storeUTM'
import { getConsent } from '@core/tracking/consent'
import { getPageUrl } from '@core/window'
import { sanitizeSensitiveQueryParams } from '@core/window/libs/url'

import { nowAndNowLocalToString } from './nowAndNowLocal'
import { locale } from './tracking.utils'

/**
 * Get global event properties for pixel tracking. These form the basis of the
 * event_properties field in the pixel tracking payload.
 */
export const getGlobalEventProperties = () => {
  const pageUrl = sanitizeSensitiveQueryParams(getPageUrl() ?? '')
  const { nowLocal } = nowAndNowLocalToString()
  const experiments = getBackendExperimentsForTracking()

  // Convert experiments to the format expected by the tracking system
  const experimentsForTracking = experiments?.map((exp) => ({
    _experiment_id: exp.experiment_id,
    variant_value: exp.variant_value,
    base_experiment_type: exp.base_experiment_type,
    name: exp.name,
  }))

  return pruneNilValues({
    locale,
    page_load_id: pageLoadIdSelector(getGlobalStore().getState()),
    ext_guest_id: getGlobalConfig().ext_guest_id,
    page_url: pageUrl,
    client_local_time: nowLocal,
    user_consent_level: getConsent(),
    tests: getABTestsForTracking(),
    experiments: experimentsForTracking,
    ...getUTM(),
    ...getFWReferrerForTracking(),
  })
}
